// extracted by mini-css-extract-plugin
module.exports = {"button":"_6eb00b8e53--button--1xglg","spinner":"_6eb00b8e53--spinner--GR0Cw"};